import React, { useState, useEffect } from 'react';
import { Radio, DateTimePicker, PropertyGrid } from '@leverege/ui-elements';
function StartTimeEditor(props) {
  const {
    attr,
    onChange,
    data
  } = props;
  const value = attr.get(data, {
    raw: true
  });
  const [now, setNow] = useState(true);
  useEffect(() => {
    if (now) {
      onChange({
        data: {
          attribute: attr
        },
        value: () => {
          return new Date();
        }
      });
    } else {
      onChange({
        data: {
          attribute: attr
        },
        value: new Date()
      });
    }
  }, [now]);
  return /*#__PURE__*/React.createElement(PropertyGrid, null, /*#__PURE__*/React.createElement(PropertyGrid.Item, {
    fillCell: true,
    label: "Release Now"
  }, /*#__PURE__*/React.createElement(Radio, {
    value: now,
    onChange: () => setNow(true)
  })), /*#__PURE__*/React.createElement(PropertyGrid.Item, {
    fillCell: true,
    label: "Schedule a Release"
  }, /*#__PURE__*/React.createElement(Radio, {
    value: !now,
    onChange: () => setNow(false)
  })), !now ? /*#__PURE__*/React.createElement(PropertyGrid.Item, {
    label: ""
  }, /*#__PURE__*/React.createElement(DateTimePicker, {
    value: value,
    onChange: onChange,
    eventData: {
      attribute: attr
    },
    variant: "formInput"
  })) : null);
}
const type = 'startTime';
export default {
  type,
  editor: StartTimeEditor
};